import { IBudgetVersionServiceItem } from '../../../models/budgetV2';

const itemKey = (item: IBudgetVersionServiceItem) =>
  item.id ? `id:${item.id}` : `ref:${item.ref ?? ''}|${item.item ?? ''}|${item.description ?? ''}`;

// The API returns the same items under `serviceItems` and `items`, so merging both duplicates them.
export const dedupeServiceItems = (items: IBudgetVersionServiceItem[]): IBudgetVersionServiceItem[] => {
  const seen = new Set<string>();
  return items.filter((item) => {
    const key = itemKey(item);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};
